export enum BankType {
    SINHAN = "SINHAN",
    WOORI = "WOORI",
    HYUNDAI = "HYUNDAI",
    KAKAO = "KAKAO",
    KOOKMIN = "KOOKMIN",
    DEFAULT = "DEFAULT"
}
//존재하는 타입
export enum BankKRType { //카드 발급사
    SINHAN = "신한",
    WOORI = "우리",
    HYUNDAI = "현대",
    KOOKMIN = "KB",
}
export enum FactorNameType { //전표인자명 statementFactorName
    KAKAO = "카카오",
    IBK = "IBK",
    NH = "NH농협",
    NAVER = "네이버",
}
export enum CardType {
    VISA = "VISA",
    MASTERCARD = "MASTERCARD",
    AMEX = "AMEX",
    DEFAULT = "DEFAULT"
}

/**
 * API 응답의 brand 문자열을 CardType enum으로 변환합니다.
 * @param apiBrand - ex: "마스터", "비자"
 * @returns CardType enum
 */
export const mapApiBrandToCardType = (apiBrand: string): CardType => {
    if (apiBrand.includes('마스터')) return CardType.MASTERCARD;
    if (apiBrand.includes('비자')) return CardType.VISA;
    if (apiBrand.includes('아멕스') || apiBrand.includes('AMEX')) return CardType.AMEX;
    return CardType.DEFAULT;
};

// FactorNameType과 BankType을 연결하는 맵을 정의
const factorToBankTypeMap: { [key: string]: BankType } = {
    [FactorNameType.KAKAO]: BankType.KAKAO,
    // [FactorNameType.NH]: BankType.NH, // 나중에 BankType.NH가 추가되면 여기에도 추가
    // [FactorNameType.IBK]: BankType.IBK,
};

const issuerBankTypeMap = [
    { checks: [BankKRType.SINHAN], type: BankType.SINHAN }, // "신한"
    { checks: [BankKRType.WOORI], type: BankType.WOORI },   // "우리"
    { checks: [BankKRType.HYUNDAI], type: BankType.HYUNDAI }, // "현대"
    { checks: [BankKRType.KOOKMIN, '국민'], type: BankType.KOOKMIN }, // "KB" 또는 "국민"
    // 새로운 카드사 추가 시, 이 배열에 한 줄만 추가하면 됩니다.
    // 예: { checks: ['롯데'], type: BankType.LOTTE },
];

export const mapApiIssuerToBankType = (issuer: string, statementFactorName?: string): BankType => {

    // 1순위: statementFactorName 확인
    if (statementFactorName) {
        // 맵의 키(factorName)들을 순회하면서
        for (const factorName in factorToBankTypeMap) {
            if (statementFactorName.startsWith(factorName)) {
                // 해당하는 BankType을 반환
                return factorToBankTypeMap[factorName];
            }
        }
    }

    // 2순위: issuer 확인 (기존 로직과 동일)
    // if (issuer.includes(BankKRType.SINHAN)) return BankType.SINHAN;
    // if (issuer.includes(BankKRType.WOORI)) return BankType.WOORI;
    // if (issuer.includes(BankKRType.HYUNDAI)) return BankType.HYUNDAI;
    // if (issuer.includes(BankKRType.KOOKMIN) || issuer.includes('국민')) return BankType.KOOKMIN;
    // ... 나머지 issuer 검사

    // 2순위: issuer 확인 (순회 방식)
    for (const mapping of issuerBankTypeMap) {
        // 'checks' 배열 안의 문자열 중 하나라도 issuer에 포함되는지 확인
        if (mapping.checks.some(checkString => issuer.includes(checkString))) {
            return mapping.type;
        }
    }

    // 3순위: Default
    return BankType.DEFAULT;
};